import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../common/modal/Modal';
import PickupManualSenderRemissionGuideForm from './PickupManualSenderRemissionGuideForm';
import {
  getManualSenderRemissionGuide,
  putPickupSenderRemissionGuide,
} from '../../../../actions/cargo/ManualSenderRemissionGuide';
import {
  SENDER_REMISSION_GUIDE_CLOSURE_STATUS,
  SENDER_REMISSION_GUIDE_ITEM_PICKUP_STATUS,
} from '../../../../config/constants';

const PickupManualSenderRemissionGuideButton = ({
  manualGrr,
  dispatchPutPickupSenderRemissionGuide,
  dispatchGetManualSenderRemissionGuide,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const onModalSubmit = async (formvalues) => {
    const senderRemissionGuideItemList = formvalues.cargoItems.map((item) => ({
      ...item,
      status:
        item.status && typeof item.status === 'object'
          ? item.status.value
          : item.status,
      closureStatus:
        item.closureStatus && typeof item.closureStatus === 'object'
          ? item.closureStatus.value
          : item.closureStatus,
    }));

    const response = await dispatchPutPickupSenderRemissionGuide(
      manualGrr.get('id'),
      {
        senderRemissionGuideItemList,
      },
    );

    if (response) {
      dispatchGetManualSenderRemissionGuide({
        SenderRemissionGuideId: manualGrr.get('id'),
      });
      setModalBody(null);
      setShowModal(false);
    }
  };

  const openModal = async () => {
    setShowModal(true);
  };
  const generateInitialValues = (values) => {
    if (!values) return {};

    const items = values.get('senderRemissionGuideItemList') || [];

    return {
      cargoItems: items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
        description: item.description,
        returnDate: item.returnDate || null,
        observation: item.observation || '',
        status: SENDER_REMISSION_GUIDE_ITEM_PICKUP_STATUS[item.status] || null,
        closureStatus:
          SENDER_REMISSION_GUIDE_CLOSURE_STATUS[item.closureStatus] || null,
      })),
    };
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <PickupManualSenderRemissionGuideForm
        onCancel={closeModal}
        onSubmit={onModalSubmit}
        initialValues={generateInitialValues(manualGrr)}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Recepcionar Guia de Remisión de Remitente Manual"
        body={modalBody}
        size="xl"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />
      <Button color="info" onClick={openModal}>
        <i className="fa fa-reply-all" /> Registrar Recepción
      </Button>
    </>
  );
};

PickupManualSenderRemissionGuideButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  manualGrr: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchPutPickupSenderRemissionGuide: PropTypes.func.isRequired,
  dispatchGetManualSenderRemissionGuide: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutPickupSenderRemissionGuide: putPickupSenderRemissionGuide,
  dispatchGetManualSenderRemissionGuide: getManualSenderRemissionGuide,
};

export default connect(
  null,
  mapDispatchToProps,
)(PickupManualSenderRemissionGuideButton);
